import { defineStore } from "pinia";
import { DefineComponent, ExtractPropTypes, shallowRef } from "vue";

export const useDialogStore = defineStore('dialog', () => {

  const dialog = shallowRef<null | DefineComponent<any, {}, any>>(null)
  const dialogProps = shallowRef<object>({})

  const open = <T>(_dialog: DefineComponent<T, {}, any>, props?: ExtractPropTypes<T>) => {
    dialog.value = _dialog as any
    dialogProps.value = props || {}
  }

  const close = () => {
    dialog.value = null
  }

  return { open, close, dialog, dialogProps }
})